import React, { useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = 'Voornaam is verplicht';
    if (!formData.lastName.trim()) newErrors.lastName = 'Achternaam is verplicht';
    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = 'Telefoonnummer is verplicht';
    } else if (!/^[0-9+\-\s()]*$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Ongeldig telefoonnummer';
    }
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Ongeldig e-mailadres';
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    
    if (Object.keys(formErrors).length === 0) {
      document.getElementById('contact-form').submit();
    } else {
      setErrors(formErrors);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  return (
    <div className="contact-form-container">
      <h2 className="contact-form-title">Zal ik u bellen?</h2>
      <form 
        action="https://formsubmit.co/jesse@corevisionconsultancy.nl" 
        method="POST"
        id="contact-form"
        onSubmit={handleSubmit} 
        className="contact-form"
      >
        {/* Customize redirect */}
        <input type="hidden" name="_next" value="https://your-website.com/bedankt" />
        <input type="hidden" name="_subject" value="Nieuwe Contact Aanvraag" />
        
        <div className="form-field">
          <label>Voornaam*</label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            className={errors.firstName ? 'error' : ''}
          />
          {errors.firstName && <span className="error-message">{errors.firstName}</span>}
        </div>

        <div className="form-field">
          <label>Achternaam*</label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            className={errors.lastName ? 'error' : ''}
          />
          {errors.lastName && <span className="error-message">{errors.lastName}</span>}
        </div>

        <div className="form-field">
          <label>E-mail</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={errors.email ? 'error' : ''}
          />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>

        <div className="form-field">
          <label>Telefoonnummer*</label>
          <input
            type="tel"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            className={errors.phoneNumber ? 'error' : ''}
          />
          {errors.phoneNumber && <span className="error-message">{errors.phoneNumber}</span>}
        </div>

        <button type="submit" className="contact-submit-btn">Bel mij</button>
      </form>
    </div>
  );
};

export default ContactForm;